var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "bag_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5 36.667V9.722h6.945c0-2.213.766-4.109 2.298-5.687 1.532-1.579 3.405-2.368 5.618-2.368 2.267 0 4.2.78 5.798 2.34 1.598 1.56 2.396 3.465 2.396 5.715H35v26.945H5Zm2.778-2.778h24.444V12.5H7.778v21.389ZM20 22.5c2.231 0 4.155-.808 5.77-2.424 1.617-1.615 2.425-3.539 2.425-5.77h-2.778c0 1.481-.533 2.754-1.597 3.819-1.065 1.065-2.339 1.597-3.82 1.597-1.481 0-2.755-.532-3.82-1.597-1.064-1.065-1.597-2.338-1.597-3.82h-2.778c0 2.232.808 4.156 2.424 5.771C15.845 21.692 17.77 22.5 20 22.5ZM14.722 9.722h10.556c0-1.481-.51-2.731-1.528-3.75-1.019-1.018-2.269-1.527-3.75-1.527-1.481 0-2.731.509-3.75 1.527-1.019 1.019-1.528 2.269-1.528 3.75Z"
}))));
export default SvgBag;